import React, { FunctionComponent, memo } from 'react';
import Typography, { TypographyProps } from '@material-ui/core/Typography';

interface IPercentageProps {
  value: number;
}
const Percentage: FunctionComponent<IPercentageProps & TypographyProps & { component?: any }> = memo(
  ({ value, ...rest }) => {
    return <Typography {...rest}>{value}%</Typography>;
  },
);

export default Percentage;
